import { EntityFactory } from './factory';
/**
 * 存放所有实体类
 */

var EntitiesStorage = new Map();
/**
 * 实体管理器
 *
 * 用于管理注册的所有实体类
 */

var EntitiesManager = function () {
  function EntitiesManager() {}
  /**
   * 注册一个实体类
   *
   * @param name 名称
   * @param desc 描述信息
   */


  EntitiesManager.register = function (name, desc) {
    if (EntitiesStorage.has(name)) {
      throw new Error("Entity " + name + " is registered.");
    }

    EntitiesStorage.set(name, EntityFactory(name, desc));
  };
  /**
   * 检查指定名称的实体是否已注册
   *
   * @param name 名称
   */


  EntitiesManager.has = function (name) {
    return EntitiesStorage.has(name);
  };
  /**
   * 获取实体类
   *
   * @param name 名称
   */


  EntitiesManager.get = function (name) {
    if (!EntitiesStorage.has(name)) {
      throw new Error("Entity " + name + " not found.");
    }

    return EntitiesStorage.get(name);
  };

  return EntitiesManager;
}();

export { EntitiesManager };